import { UserBusinessFeatures } from '../entity/business-features.entity';
export class USMarket implements UserBusinessFeatures {
  getUserAddressFeatures() {
    return {
      showApartmentBeforeStreet: false,
    };
  }
}
